import React from "react";
import { ChevronRight } from "lucide-react";
import { IoSparkles } from "react-icons/io5";
import styles from "./ChatbotPanel.module.css";

export const SuggestionCard = ({ question, onClick, delay = 0 }) => (
  <button
    className={styles.suggestionCard}
    style={{ animationDelay: `${delay}ms` }}
    onClick={onClick}
  >
    <div className={styles.suggestionGlow} />

    <div className={styles.suggestionContent}>
      <div className={styles.suggestionLeft}>
        <div className={styles.suggestionIcon}>
          <IoSparkles color="#facc15" />
        </div>
        <span className={styles.suggestionText}>{question}</span>
      </div>

      <ChevronRight size={16} className={styles.suggestionArrow} />
    </div>
  </button>
);

const SuggestionsPanel = ({ questions = [], onSelect }) => (
  <div className={styles.suggestionsWrap}>
    <div className={styles.suggestionHeader}>
      <div className={styles.suggestionBadge}>AI Suggestions</div>
      <div className={styles.suggestionTitle}>What would you like to know?</div>
    </div>

    <div className={styles.suggestionsGrid}>
      {questions.map((q, i) => (
        <SuggestionCard
          key={q}
          question={q}
          onClick={() => onSelect(q)}
          delay={i * 80}
        />
      ))}
    </div>
  </div>
);

export default SuggestionsPanel;
